module.exports = __webpack_public_path__ + "img/icon-fiat-white.2090db1e.svg";